import React, { useContext } from 'react';
import { SignedInContext } from '../../context/signed_in_context';
import Checkbox from '../../../components/react/checkbox/checkbox';

const OptOutOfAllEmails: React.FC = () => {
  const { isOptedOutOfAllEmails, toggleOptedOutOfAllEmails } = useContext(SignedInContext);

  return (
    <div className='row'>
      <div className='col-10'>
        <p className='mb-1 fw-bold'>
          Opt out of all Devex emails, including newsletters and alerts.
        </p>
        <p className='mb-0'>You will still receive emails related to your account.</p>
      </div>
      <div className='col-2 pt-2 text-end'>
        <Checkbox
          isSlider
          isToggled={isOptedOutOfAllEmails}
          handleChange={toggleOptedOutOfAllEmails}
        />
      </div>
    </div>
  );
};

export default OptOutOfAllEmails;
